import classNames from "classnames"
import React from "react"
import ReactSlider, { ReactSliderProps } from "react-slider"

interface IProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
}

const Slider: React.FC<IProps> = ({
  value,
  onChange,
  min = 0,
  max = 100
}): JSX.Element => {

  const renderTrack: ReactSliderProps["renderTrack"] = (trackProps, state) => {
    const { key, ...restProps } = trackProps
    return (
      <div
        key={key}
        {...restProps}
        className={classNames(
          "h-1", "rounded-full", {
            "bg-white": state.index == 1,
            "bg-ch-blue-500": state.index == 0
          }
        )}
      />
    )
  }

  const renderThumb: ReactSliderProps["renderThumb"] = (thumbProps) => {
    const { key, ...restProps } = thumbProps
    return (
      <div
        key={key}
        {...restProps}
        className="w-6 h-6 rounded-full bg-white cursor-pointer outline-none focus:bg-ch-blue-400"
      />
    )
  }

  return (
    <div className="slider w-full py-2 px-3 bg-ch-gray-600 rounded-full">
      <ReactSlider
        className="slider w-full h-6 overflow-hidden flex items-center"
        renderTrack={renderTrack}
        renderThumb={renderThumb}
        value={value}
        onChange={(val: number) => onChange(val)}
        max={max}
        min={min}
      />
    </div>
  )
}

export default Slider
